module.exports = "<div class=\"alert alert-dismissible fade show\" [ngClass]=\"message.type === 'INFO' ? 'alert-info': 'alert-danger'\" role=\"alert\"\n    *ngFor=\"let message of messages()\">\n    <button type=\"button\" class=\"close\" (click)=\"remove(message)\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button> {{message.text}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/messages/messages.component.html
// module id = ../../../../../src/app/messages/messages.component.html
// module chunks = main